import { LexerToken } from '@digitalbranch/earley-parser'

const Keywords = [
  'await',
  'break',
  'case',
  'catch',
  'class',
  'const',
  'continue',
  'debugger',
  'default',
  'delete',
  'do',
  'else',
  'enum',
  'export',
  'extends',
  'false',
  'finally',
  'for',
  'function',
  'if',
  'import',
  'in',
  'instanceof',
  'new',
  'null',
  'return',
  'super',
  'switch',
  'this',
  'throw',
  'true',
  'try',
  'typeof',
  'var',
  'void',
  'while',
  'with',
  'yield',
]

const Tokens: LexerToken[] = [
  {
    name: 'BEGINCOMMENT',
    test: /^\/\*/,
    enterState: 'COMMENT',
  },
  {
    name: 'NEWLINE',
    test: /^[\n\r]/,
    lineBreaks: true,
    // If set to true newlines are tokenized and used for automated semicolon insertion
    shouldTokenize: (lex: any) => {
      // lex.line += 1
      // lex.col = 0
      // return true

      return false
    },
  },
  {
    name: 'NULL',
    test: /^null/,
    value: () => null,
  },
  {
    name: 'NUMBER',
    test: /^[0-9]+(?:\.?[0-9]+)*/,
    value: (str: string) => parseFloat(str),
  },
  {
    name: 'STRING',
    test: /^(?:"(?:[^"\\]|(?:\\.))*")|'(?:[^'\\]|(?:\\.))*'/,
    value: (str: string) => str.slice(1, -1),
  },
  {
    name: 'FALSE',
    test: /^false/,
    value: () => false,
  },
  {
    name: 'TRUE',
    test: /^true/,
    value: () => true,
  },
  {
    name: 'IDENTIFIER',
    test: /^[$_\p{ID_Start}]+[$_\p{ID_Continue}]*/u,
    guard: (match: string) => !Keywords.includes(match),
  },
  ['RETURN'],
  ['FUNCTION'],
  ['THIS'],
  ['SEMI', ';'],
  ['COMMA', ','],
  ['DOT', '.'],
  ['PERIOD', ':'],
  ['PLUSIS', '+='],
  ['MULTIPLY', '*'],
  ['DIVIDE', '/'],
  ['INCREMENT', '++'],
  ['MODULUS', '%'],
  ['PLUS', '+'],
  ['DECREMENT', '--'],
  ['MINUS', '-'],
  ['TENARY', '?'],
  ['ARROW', '=>'],
  ['NOTSTRICTEQUAL', '!=='],
  ['STRICTEQUAL', '==='],
  ['EQUALEQUAL', '=='],
  ['NOTEQUAL', '!='],
  ['LOGNOT', '!'],
  ['EQUAL', '='],
  ['LT', '<'],
  ['LTEQ', '<='],
  ['GT', '>'],
  ['GTEQ', '>='],
  ['LOGOR', '||'],
  ['XLOGOR', '^'],
  ['LOGAND', '&&'],
  ['BINOR', '|'],
  ['NOT', '~'],
  ['BINAND', '&'],
  ['LPAREN', '('],
  ['RPAREN', ')'],
  ['LCBRACE', '{'],
  ['RCBRACE', '}'],
  ['LBRACK', '['],
  ['RBRACK', ']'],
]

export default Tokens
